<template>
  <div class="riskLevel">
    <top :toolSort="toolSort"></top>
    <el-divider></el-divider>
      <div class="cell">
        <div class="label" :style="{flex:$isMobile?3:1}">行业分类：</div>
        <div class="value" :style="{flex:$isMobile?10:8}">
          <el-cascader
          :size="$isMobile ? 'mini' : 'medium'"
          :clearable='true'
          ref='industry'
          v-model="checkedCategory"
          @change="onChange"
              placeholder="请输入关键字"
              :options="options"
              filterable></el-cascader>
        </div>
      </div>
      <div class="cell">
        <div class="label">
          职业病危害风险分类：
        </div>
        <div class="value" :style="{color:level.color}">{{level.value}}</div>
      </div>
  </div>
</template>
<script>
  import industryCategory from '../../../util/industryCategory.js'
  import top from '../../subComponents/top.vue'
  export default{
    data(){
      return{
        checkedCategory:'',
        color:{},
        checkedNode:{},
        toolSort:'',
        options:[],
        level:'',
      }
    },
    
    watch:{
       checkedCategory(val){
         if(!val[0]){
           this.level = ''
         }
       }
    },
    created() {
      this.toolSort = this.$route.params.sort
      this.getIndustryCategory()
    },
    methods:{
      onChange(node,data){
         setTimeout(()=>{
           this.checkedNode = this.$refs.industry.getCheckedNodes()
           if(!this.checkedNode[0]) return
           const level = this.checkedNode[0].data.riskType
           if(level === 2){
             this.level = {value:'严重',color:'#F56C6C'}
           }else{
             this.level = {value:'一般',color:'#409EFF'}
           }
         },20)
      },
       async getIndustryCategory(){
         let res = await this.$axios.get(this.$serviceAPI.findIndustryCategory)
          if(res.data.code === 200){
            this.options = res.data.data
          }
       }
    },
    components:{top}
  }
</script>

<style scoped="scoped">
  .cell{
    display: flex;
    align-items: center;
    margin-bottom: 50px;
  }
  .cell .label{
    color: #333;
    font-size: 14px;
  }
  .cell .value{
    font-weight: 510;
  }
  .cell .el-cascader{
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/subPage/riskLevel/riskLevel.vue